import { absolutePath } from "../absolutePath";

export const spaces = {
  show: (id: number) => absolutePath(`access_registry/spaces/${id}`),
};
